var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"item"},[_c('div',{staticClass:"item-header"},[_c('div',{staticClass:"type",class:[_vm.type]},[_c('i',{class:{
         'fab fa-facebook-f' : _vm.type === 'facebook',
         'fab fa-instagram' : _vm.type === 'instagram',
         'fab fa-whatsapp' : _vm.type === 'whatsapp', 
         'fas fa-comment' : _vm.type === 'lhc' || _vm.type === 'web'
        }})]),_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(_vm.name)+" - "+_vm._s(_vm.dept))]),_c('p',{staticClass:"mb-0 time"},[_vm._v(_vm._s(_vm._f("redeableDate")(_vm.datetime)))])]),_c('div',_vm._l((_vm.tags),function(tag){return _c('the-tag',{key:tag.id,attrs:{"tag":tag}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }